import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <router-outlet />
    <a class="powered-by-badge" href="https://www.hifiinfotech.com" target="_blank" rel="noopener noreferrer">
      <img src="assets/h hifi logo.png" alt="" aria-hidden="true">
      <span>Powered by</span>
      <strong>HIFI Infotech</strong>
      <span>www.hifiinfotech.com</span>
    </a>
  `
})
export class AppComponent {}
